(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const root = document.documentElement;
    const loaderSelector = 'script[src*="assets.motive.co/front-loader/"]';
    let timer;
    let deadline;
    let failed = false;

    function stopWaiting() {
      clearInterval(timer);
      clearTimeout(deadline);
    }

    function updateAvailability() {
      const ready = !failed && typeof window.initX === 'function' && !!document.querySelector(loaderSelector);
      root.classList.toggle('lowplex-motive-ready', ready);
      if (ready || failed) stopWaiting();
      return ready;
    }

    function waitForMotive() {
      stopWaiting();
      if (!updateAvailability() && !failed && document.querySelector(loaderSelector)) {
        timer = setInterval(updateAvailability, 250);
        deadline = setTimeout(stopWaiting, 30000);
      }
    }

    document.addEventListener('load', event => {
      if (event.target instanceof Element && event.target.matches(loaderSelector)) waitForMotive();
    }, true);

    window.addEventListener('error', event => {
      if (event.target instanceof HTMLScriptElement && event.target.src.startsWith('https://assets.motive.co/')) {
        failed = true;
        updateAvailability();
      }
    }, true);

    document.addEventListener('motive-x:init', () => {
      failed = false;
      updateAvailability();
    });
    window.addEventListener('pageshow', waitForMotive);
    waitForMotive();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
